/**
 * String↔boolean coercion helpers for ToggleButtonGroup.
 *
 * ToggleButtonGroup works with string values; the API uses boolean|null.
 *   null/undefined → null  (nothing selected — tri-state preserved)
 *   true           → "true"
 *   false          → "false"
 */
export const boolToString = (v: boolean | null | undefined): string | null => {
	if (v === null || v === undefined) {
		return null;
	}
	return v ? "true" : "false";
};

export const stringToBool = (s: string): boolean | null => {
	if (s === "true") {
		return true;
	}
	if (s === "false") {
		return false;
	}
	return null;
};
